/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerFileStorageSourceComponent', [
    '$rootScope',
    'DesignerBaseSourceAndDestinationComponent',
    'DesignerConnection',

    function ($rootScope, DesignerBaseSourceAndDestinationComponent, DesignerConnection) {
      const FILE_PATH = 'file_path';

      function DesignerFileStorageSourceComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        this.cloud_storage_connection_id = null;
        this.bucket = null;
        this.path = null;
        this.manifest_path = null;
        this.manifest_bucket = null;
        this.manifest_connection = new DesignerConnection();
        this.source_path_field_alias = null;
        this.char_encoding = null;
        this.before_action = null;
        this.record_delimiter = null;
        this.record_type = null;
        this.record_settings = null;
        this.json_path = null;
        this.extraFields = [
          {
            name: FILE_PATH,
            alias: FILE_PATH,
            data_type: 'string',
          },
        ];
      }

      DesignerFileStorageSourceComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerFileStorageSourceComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          cloud_storage_connection_id: String(this.connection.id || ''),
          bucket: this.bucket || '',
          path: this.path || '',
          manifest_path: this.manifest_path || '',
          manifest_bucket: this.manifest_bucket || '',
          manifest_connection: this.manifest_connection.getData(),
          source_path_field_alias: this.source_path_field_alias || '',
          char_encoding: this.char_encoding || 'utf-8',
          before_action: this.before_action || 'none',
          record_delimiter: this.record_delimiter || 'new_line',
          record_type: this.record_type || 'delimited',
          json_path: this.json_path || '$',
          record_settings: this.record_settings || {
            field_delimiter: ',',
            text_qualifier: '',
            skip_header: true,
            escape_character: '"',
          },
        });

        return data;
      };

      DesignerFileStorageSourceComponent.prototype.getFormData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getFormData.call(this);

        // var pathField = _.find(data.schema.fields, { name: FILE_PATH });
        //
        // if (this.source_path_field_alias && this.source_path_field_alias.length > 0 && angular.isUndefined(pathField)) {
        //     data.schema.fields.unshift({
        //         name: FILE_PATH,
        //         alias: this.source_path_field_alias,
        //         data_type: 'string',
        //         disableTypeEdit: true
        //     });
        // }

        if (data.before_action === 'copy' && data.manifest_connection && data.manifest_connection.type)
          data.before_action = 'copy_manifest';

        // if (data.record_settings && data.record_settings.text_qualifier === '') data.record_settings.text_qualifier = 'none';

        data.extraFields = _.clone(this.extraFields);

        return data;
      };

      DesignerFileStorageSourceComponent.prototype.setFormData = function (data) {
        if (data.before_action === 'copy_manifest') {
          if (data.manifest_path) {
            data.before_action = 'copy';
          } else {
            data.before_action = 'none';
            data.manifest_connection = null;
          }
        } else if (data.before_action === 'copy') {
          delete data.manifest_bucket;
          delete data.manifest_connection;
          delete data.manifest_path;
        }

        this.setData(data);

        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerFileStorageSourceComponent.prototype.setData = function (data) {
        if (data.record_settings && data.record_settings.text_qualifier === 'none') {
          data.record_settings.text_qualifier = '';
        }

        if (!data.manifest_connection && data.manifest_path && data.before_action !== 'copy_manifest') {
          this.manifest_connection.setData(data.connection);
        } else {
          this.manifest_connection.setData(data.manifest_connection);
        }

        this.cloud_storage_connection_id = String(this.connection.id || '');
        this.bucket = data.bucket;
        this.path = data.path;
        this.char_encoding = data.char_encoding;
        this.before_action = data.before_action;
        this.record_delimiter = data.record_delimiter;
        this.record_type = data.record_type;
        this.source_path_field_alias = data.source_path_field_alias;
        this.json_path = data.json_path;
        this.manifest_path = data.manifest_path;
        this.manifest_bucket = data.manifest_bucket;
        if (data.record_settings) {
          this.record_settings = {
            field_delimiter: data.record_settings.field_delimiter,
            text_qualifier: data.record_settings.text_qualifier,
            skip_header: data.record_settings.skip_header,
            escape_character:
              data.record_settings.escape_character === 'none' || data.record_settings.escape_character === ''
                ? '"'
                : data.record_settings.escape_character,
          };
        }

        const $package = $rootScope.getPackage();

        if (
          this.record_type === 'delimited' &&
          data.schema &&
          $package &&
          (!$package.flow_version || $package.flow_version.startsWith('1'))
        ) {
          _.each(data.schema.fields, function (field) {
            field.name = field.alias;
          });
        }

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerFileStorageSourceComponent.prototype.getSchema = function () {
        const schema = DesignerBaseSourceAndDestinationComponent.prototype.getSchema.call(this);

        if (
          this.source_path_field_alias &&
          this.source_path_field_alias.length > 0 &&
          !schema.fields.find((item) => item.name === this.source_path_field_alias)
        ) {
          schema.fields.unshift({
            name: this.source_path_field_alias,
          });
        }

        return schema;
      };

      return DesignerFileStorageSourceComponent;
    },
  ]);
})(window.angular);
